import { macroCondition, isTesting } from "@embroider/macros";

export default function () {
  let duration = macroCondition(isTesting()) ? 0 : 500;

  this.transition(
    this.hasClass("usageGuide"),

    this.toValue(true),
    this.use("toDown", { duration }),
    this.reverse("fade", { duration }),
  );
}
